import { Directive, ElementRef, Input, OnInit } from '@angular/core';

@Directive({
    selector: '[focusOnCreate]'
})
export class FocusOnCreateDirective implements OnInit {

    @Input('focusOnCreate') active: boolean;

    constructor(private el: ElementRef) { }

    ngOnInit(): void {
        if (this.active) {
            this.el.nativeElement.focus()
        }
    }

}